module.exports = __webpack_public_path__ + "coin_C2P.png?80e864d5875be64cc378ad1c84c3d50f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_C2P.png
// module id = 1125
// module chunks = 2